import { errorPlayerContainerNotCreated } from './errors';
export const playerSeek = (container, position) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return player.seek(position.time);
};
export const playerSeekForward = (container, seekForward) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return player.seekForward(seekForward.steps);
};
export const playerSeekBackward = (container, seekBackward) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return player.seekBackward(seekBackward.steps);
};
export const playerSeekToAdBreakEnd = (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return player.seekToAdBreakEnd();
};
